import config from "config";

export const zeroFrictionSignUpEnabled =
  config.REACT_APP_ZERO_FRICTION_SIGN_UP_ENABLED === "true";
